const changeDisplayMode = () => {
    const toBlocks = document.querySelector('.products__blocks'),
          toLine = document.querySelector('.products__inline'),
          productsGrid = document.querySelector('.products__grid');
          

    if(toBlocks) {
        const items = productsGrid.querySelectorAll('.item');
        toBlocks.addEventListener('click', (e) => {
            e.preventDefault();
            toBlocks.classList.add('active_link');
            toLine.classList.remove('active_link');
            productsGrid.classList.remove('products__grid_inline');
            items.forEach(item => {
                item.classList.remove('item_inline');
            });
            
        })
        toLine.addEventListener('click', (e) => {
            e.preventDefault();
            toLine.classList.add('active_link');
            toBlocks.classList.remove('active_link');
            productsGrid.classList.add('products__grid_inline');
            items.forEach(item => {
                item.classList.add('item_inline');
            });
        })
        window.addEventListener('resize', () => {
            if(document.documentElement.clientWidth < 768) {
                toBlocks.classList.add('active_link');
                toLine.classList.remove('active_link');
                toBlocks.style.display = 'none';
                toLine.style.display = 'none';
                productsGrid.classList.remove('products__grid_inline');
                items.forEach(item => {
                    item.classList.remove('item_inline');
                });
            } else {
                toBlocks.style.display = 'block';
                toLine.style.display = 'block';
            }
        })
    }
}

export default changeDisplayMode;